<template lang="pug" functional>
ul(
  class="nav-list"
  :class="{compact: compact && level === 1, submenu: level > 1}"
)
  list-item(
    class="nav-item"
    v-for="item, index in items"
    :text="item.text"
    :items="item.children"
    :to="item.to"
    :external="item.external"
    :target="item.target"
    :callback="item.callback"
    :key="index"
    :level="level"
    :wide="level === 1 && small"
    :max-level="maxLevel"
  )
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    items: {
      type: Array,
      default: () => [],
    }
    ,
    level: {
      type: Number,
      default: 1,
    },

    maxLevel: {
      type: Number,
      required: false,
    },

    small: {
      type: Boolean,
      default: false
    },

    compact: {
      type: Boolean,
      default: false,
    }
  }
})

export default class List extends Vue {
  beforeCreate() {
    this.$options.components.ListItem = require('./Item.vue');
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/helpers/mediaqueriesStep'

.nav-list
  width 100%
  .nav-item
    display inline-block
    vertical-align middle
    clear none
    margin 8px 1% 0 0
    padding 0
    +phone-only()
      width 100%
    +tablet()
      width 33%
      display inline-block
      &:last-of-type
        margin-right 0
    +desktop()
      width: 19%
      display table-cell
      padding-right 5px
      &:last-of-type
        padding-right 0
  &.compact
    display block
    width 100%
    +desktop()
      display flex
      flex-wrap wrap
    & > .nav-item
      +phone-only()
        display inline-block
        width 100%
        padding 0
        margin 0
      +tablet()
        display inline-block
        width 31.66%
        margin 10px 0.5% 0
        padding 0
      +desktop()
        width auto
        display table-cell
        padding-right 5px
        margin 2px 0
        flex-grow: 1;
        &:first-child
          padding-left 0
</style>



// WEBPACK FOOTER //
// List.vue?3acc99da